module.exports = __webpack_public_path__ + "img/opportunity-hot.7a17713d.svg";